import { BrokerAgreementSummary } from '../../../../../../../queries/brokerAgreementQueries';

/** The agreement broker's street lines, then city, state and zip (only when all three are known). */
export const BrokerAddress = ({ broker }: { broker: NonNullable<BrokerAgreementSummary['broker']> }) => {
    return (
        <>
            {broker.street1 && <div>{broker.street1}</div>}
            {broker.street2 && <div>{broker.street2}</div>}
            {broker.city && broker.state && broker.zipCode && (
                <div>
                    {broker.city}, {broker.state} {broker.zipCode}
                </div>
            )}
        </>
    );
};
